/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid } from "@material-ui/core";
import { store } from "../../Context/Store";
import { Province, Province_Center } from "../../utils/constant";
import { SelectStyle } from "./style";
import { useContext, useEffect, useRef, useState } from "react";

import getIcon from "../../utils/getIcon";

const SelectProvince = (props) => {
  const classes = SelectStyle();
  const wrapperRef = useRef(null);

  const [ShowProvince, setShowProvince] = useState(false);
  const [ProvinceCode, setProvinceCode] = useState(25);

  const context = useContext(store);
  const { dispatch } = context;

  useEffect(() => {
    if (ProvinceCode) {
      dispatch({ type: "SET_PROVINCE", prov: ProvinceCode });
    }
  }, [ProvinceCode]);


  const getKeyByValue = (code) => {
    return Object.keys(Province).find(p => Province[p] === code)
  }

  const flyToCity = (code) => {
    dispatch({ type: "FLY_TO_CITY", coords: Province_Center[code - 1] })
  }

  useEffect(() => { // close select box when click outside of list
    const handleClickOutside = (e) => {
      if (wrapperRef?.current && !wrapperRef.current.contains(e.target)) {
        setShowProvince(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);


  return (
    <Grid>
      <Box onClick={() => setShowProvince(prev => !prev)} className={classes.wrapper}>
        {getIcon("chevronDown",
          {
            cursor: 'pointer',
            width: 18,
            heigh: 18,
            transform: `rotate(${ShowProvince ? "180deg" : "0deg"})`
          })}
        {getKeyByValue(ProvinceCode)}
      </Box>
      {ShowProvince && <Grid ref={wrapperRef} className={classes.provinceList}>
        {Object.keys(Province).map(prov => (
          <Grid
            onClick={(e) => {
              e.stopPropagation();
              setProvinceCode(Province[prov]);
              setShowProvince(false);
              flyToCity(Province[prov])
            }}
            key={Province[prov]}
            className={classes.item}
          >
            {prov}
          </Grid>
        ))}
      </Grid>}
    </Grid>
  );
};

export default SelectProvince;
